module.exports = __webpack_public_path__ + "static/media/juridique.66e0ee29.jpg";